import React from 'react';
import {Menu, MenuDropdownProps} from '@mantine/core';

export const EtroMenuDropdown: React.FC<MenuDropdownProps> = props => {
  return <Menu.Dropdown {...props} />;
};
